<template src="./Input.html"></template>
<style src="./Input.scss" lang="scss"></style>

<script>
	// TODO: length of suggest list must be as a variable instead of hardcoded magic-text in JS&CSS
	import Button from '@/components/Button/Button';
	import Icon from '@/components/Icon/Icon';
	import { Helper } from '@/services/helper/helper';

	export default {
		name: 'HpInput',
		props: {
			value: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				withButton: false,
				buttonImportance: 'input',
				buttonActive: false,
				pointer: -1,
				originValue: '',
				brand: ''
			};
		},
		watch: {
			// shouldn't watch the object value 'cause it never changes
			pointer() {
				this.$emit('input', this.value);
			}
		},
		methods: {
			switchPasswordVisibility() {
				const trueType = this.$el.querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password';
				this.$el.querySelector('input').setAttribute('type', trueType);
				this.buttonActive = !this.buttonActive;
			},
			searchAction($event) {
				this.$emit('formsubmit', $event);
			},
			searchReset($event) {
				this.value.suggest.response = [];
				this.$emit('formreset', $event);
			},
			inputHandler() {
				if (this.value.suggest) {
					if (!this.value.inputvalue || !this.value.suggest || !this.value.suggest.url) {
						this.value.suggest.response = [];
						return undefined;
					}
				}
				// JS way of input length constraint
				let upperLimit = this.value.maxLength || 1024;
				if (this.value.inputvalue.length > upperLimit) {
					this.value.inputvalue = this.value.inputvalue.slice(0, upperLimit);
				}
				this.originValue = this.value.inputvalue;
				this.value.inputvalue.length > 2 &&
					this.xhr(this.value.suggest.url + this.value.inputvalue)
						.then((res) => {
							this.value.suggest.response = JSON.parse(res.response.replace(/^suggest\(/i, '').replace(/\].*;$/i, ']'));
						})
						.catch((error) => {
							console.log('ERROR: ', error);
						});
			},
			xhr(url, method) {
				const request = new XMLHttpRequest();
				return new Promise((resolve, reject) => {
					request.onreadystatechange = function() {
						if (request.readyState !== 4) {
							return;
						}
						if (request.status >= 200 && request.status < 300) {
							resolve(request);
						} else {
							reject(request);
						}
					};
					request.open(method || 'GET', url, true);
					request.send();
				});
			},
			selectUp() {
				let list = document.querySelectorAll('#' + this.value.suggest.id + ' li') || [];
				if (!list.length) {
					return undefined;
				}
				let upperIndex = list.length > 5 ? 4 : list.length - 1;
				if (--this.pointer < -1) {
					this.pointer = upperIndex;
					this.value.inputvalue = list[this.pointer].textContent;
				} else if (this.pointer === -1) {
					this.value.inputvalue = this.originValue;
				} else {
					this.value.inputvalue = list[this.pointer].textContent;
				}
				this.value.index = this.pointer;
			},
			selectDown() {
				let list = document.querySelectorAll('#' + this.value.suggest.id + ' li') || [];
				if (!list.length) {
					return undefined;
				}
				if (++this.pointer < list.length && Helper.isElementVisible(list[this.pointer])) {
					this.value.inputvalue = list[this.pointer].textContent;
				} else {
					this.pointer = -1;
					this.value.inputvalue = this.originValue;
				}
				this.value.index = this.pointer;
			},
			setValue($event, val, index) {
				this.value.index = index < 0 ? -1 : index;
				this.value.inputvalue = val;
				this.value.suggest.response = [];
				this.pointer = index < 0 ? -1 : index;
				setTimeout(() => {
					this.searchAction($event);
				}, 100);
			},
			placeholderFocusOnce($event) {
				$event.target.removeAttribute('data-placeholder-focus-once');
			}
		},
		mounted() {
			const brand = process.env.VUE_APP_BRAND;
			this.brand = brand === 'webde' ? 'WEB.DE' : brand === 'gmx' ? 'GMX' : '1&1';

			if (this.value.inputType === 'search') {
				if (brand === 'webde') {
					this.buttonImportance = 'primary';
				} else {
					this.buttonImportance = 'accent';
				}
			}

			this.$el.querySelector('input').setAttribute('type', this.value.inputType === 'search' ? 'text' : this.value.inputType);

			this.withButton = this.value.inputType === 'search' || this.value.inputType === 'password';
		},
		components: {
			'hp-button': Button,
			'hp-icon': Icon
		}
	};
</script>
